<script>
    

  </script>
  
  
  <style>
  * {
    box-sizing: border-box;
  }
  
  .row::after {
    content: "";
    clear: both;
    display: table;
  }

  .row{
    justify-items: center;
  }
  
  [class*="col-"] {
    float: left;
    padding: 15px;
  }
 
  

  h6{
    margin:5px 0;
    padding:  0;
  }




.col-3 {width: 25%;}

.col-5 {width: 30%;}
.col-6 {width: 50%;}
.col-7 {width: 40%;}

.col-12 {width: 100%;}

.trabalhos{
  padding-top: 10px;
  
}
.trabalhos p{
  margin:0;
}
.trabalhos h4{
  margin:15px 0;
}

li {
    font-family: var(--FONT_CABIN);
    font-size: 18px;
    list-style-image: url("../../../assets/images/recursos/list_bullet.svg");
    margin-bottom: 0;
  }
  li:not(:last-child) {
    margin-bottom: 0;
  }
</style>


























  <div class="" id='' style="margin: 0 16vw 0 11vw">
    <div class="row" style="justify-content: center;">
      <div class="col-5" style="width: 300px;justify-content: center;text-align: center;">
        <img alt='' style="margin:10%  10% 0 0;width: 90%;" src="assets/Consultas disponiveis/TJ.png"/>
      </div>
      <div class="col-7" style="padding: 0; min-width: 300px;">
        <div class="trabalhos">
            <h2>TRT - Certidão de Ações Trabalhistas
            </h2>
              <h4>Para que serve?</h4>
            <p style="padding: 0 ;">
              As certidões dos Tribunais Regionais do Trabalho atestam que uma pessoa ou empresa possui ou não alguma ação de natureza trabalhista, em primeira ou segunda instância.
<br>
              Ao todo são 24 tribunais no Brasil.
              <br>
              Para verificar são as regiões tos tribunais veja este link: https://www.tst.jus.br/justica-do-trabalho
              <br>
              O Plexi já disponibiliza consultas a várias certidões e irá disponibilizar às demais. Você tem urgência em utilizar alguma consulta? Envie-nos uma solicitação clicando aqui.
              
                          </p>
            
            <div><h4>URL da consulta:</h4>
            <p>

              TRF2 - Estado de São Paulo: <a href="https://aplicacoes10.trt2.jus.br/certidao_trabalhista_eletronica/public/index.php/index/solicitacao">https://aplicacoes10.trt2.jus.br/certidao_trabalhista_eletronica/public/index.php/index/solicitacao</a>
              <br>
              TRF3 - Estado de Minas Gerais: <a href="https://sistemas.trt3.jus.br/certidao/feitosTrabalhistas/aba1.emissao.htm">https://sistemas.trt3.jus.br/certidao/feitosTrabalhistas/aba1.emissao.htm</a>
              <br>
              TRF4 - Estado do Rio Grande do Sul: <a href="https://pje.trt4.jus.br/certidoes/trabalhista/emissao">https://pje.trt4.jus.br/certidoes/trabalhista/emissao</a>
              <br>
              TRT5 - Estado da Bahia: <a href="https://www.trt5.jus.br/certidao-eletronica/1">https://www.trt5.jus.br/certidao-eletronica/1</a>
              <br>
              TRT6 - Estado de Pernambuco: <a href="https://apps.trt6.jus.br/certidao/emitir">https://apps.trt6.jus.br/certidao/emitir</a>
              <br>
              TRT7 - Estado do Ceará: <a href="https://portaldeservicos.trt7.jus.br/portalservicos/">https://portaldeservicos.trt7.jus.br/portalservicos/</a>
              <br>
              TRT9 - Estado do Paraná: <a href="https://www.trt9.jus.br/portal/pagina.xhtml?secao=14&pagina=CERTIDAO_PJE">https://www.trt9.jus.br/portal/pagina.xhtml?secao=14&pagina=CERTIDAO_PJE</a>
              <br>
              TRT10 - Distrito Federal e Tocantins: <a href="https://www.trt10.jus.br/certidao_online/jsf/publico/certidaoOnline.jsf?idTRT10M=77">https://www.trt10.jus.br/certidao_online/jsf/publico/certidaoOnline.jsf?idTRT10M=77</a>
              <br>
              TRT15 - Cidades do interior do estado de São Paulo: <a href="https://trt15.jus.br/servicos/certidoes/certidao-eletronica-de-acoes-trabalhistas-ceat">https://trt15.jus.br/servicos/certidoes/certidao-eletronica-de-acoes-trabalhistas-ceat</a>
            </p>


              <p style="margin:30px 0 0 0;"><b><br>Quer saber mais informações? </b><br>Acesse <a href="https://www.tst.jus.br/justica-do-trabalho">https://www.tst.jus.br/justica-do-trabalho</a></p>

              <br><br><a href="#/consultas" style="">
                <h5 style="">Voltar para a lista de consulta</h5>
          </a></div>

            

        </div>
        <div class="bloco" style='margin-top:30px;'>
          <div class="card shadow-sm" style='height: 100%;background-color: #01e7e5;margin: 0; display: flex;
flex-direction: row; padding: 10px 0px 10px 0px; justify-content: center;'>
            <div class="card-body" style='flex-grow: 1;'>
              <h2 style='margin:0;padding: 0vw;'>Ficou com alguma dúvida?</h2>
            </div>    
            <div style="margin:auto; text-align:right; flex-grow: 1; display: flex; align-content: center; justify-content: center;">
    <a href="#/contato" style="display: inline-block;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #fff;
    padding: 0.375rem 0.75rem;
    color: #000;
    border: 2px solid #000;
    padding: 15px 22px 15px 22px;
    border-radius: 0;
    font-weight: 800;
    margin: 0;
    width: auto;
    position: relative;
    font-size: 1rem;
    line-height: 1rem;
    text-transform: uppercase;
    letter-spacing: .5px;
    -webkit-transition: background .4s,border .4s,color .4s;
    transition: background .4s,border .4s,color .4s;
    white-space: break-spaces;
    text-decoration: none;
    ">
<span>Como podemos te ajudar?</span>

<div style="

display: block;
position: absolute;
top: calc(100% + 2px);
left: calc(0% - 2px);
width: calc(100% + (2 * 2px));
border-top: 4px solid #000;
border-left: 8px solid rgba(0,0,0,0);
border-right: 8px solid rgba(0,0,0,0);
height: 0;
margin:0;
padding:0;
-webkit-box-sizing: border-box;
box-sizing: border-box;"></div>
    </a>
      </div>  </div>    </div>
      </div>
    </div>
  </div>





